
const firebaseConfig = {
  apiKey: "AIzaSyDNWjUk3rhcubXuPw9ZYXe-VXkXqLyRlAY",
  authDomain: "matrix-7bca4.firebaseapp.com",
  databaseURL: "https://matrix-7bca4-default-rtdb.firebaseio.com",
  projectId: "matrix-7bca4",
  storageBucket: "matrix-7bca4.appspot.com",
  messagingSenderId: "813355246029",
  appId: "1:813355246029:web:4d47aa48e827bfe11fa484",
  measurementId: "G-MPYV12QTMW"
};

//firebase.analytics();

export default firebaseConfig;
